import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Manage({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
      transitionEnd: {
        fill: "var(--primary)",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        variants={iconPath}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300.787 350.799C294.599 350.799 289.582 345.783 289.582 339.594C289.582 333.405 294.598 328.389 300.787 328.389C309.34 328.389 316.301 321.428 316.301 312.875C316.301 304.323 309.34 297.363 300.787 297.363L233.198 297.481C233.192 297.481 233.184 297.481 233.177 297.481C231.378 297.481 229.604 297.047 228.008 296.217L169.684 265.885L107.214 265.885C101.025 265.885 96.0088 260.869 96.0088 254.68C96.0088 248.491 101.025 243.475 107.214 243.475L172.424 243.475C174.224 243.475 175.997 243.908 177.593 244.738L235.907 275.065L300.767 274.953C321.698 274.953 338.71 291.964 338.71 312.874C338.71 333.785 321.698 350.799 300.787 350.799Z"
      />
      <motion.path
        variants={iconPath}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.948 428.11H239.681C238.302 428.11 236.935 427.857 235.647 427.359L134.603 388.374H107.991C101.802 388.374 96.7861 383.358 96.7861 377.169C96.7861 370.98 101.802 365.964 107.991 365.964H136.69C138.068 365.964 139.436 366.218 140.724 366.715L241.767 405.7L275.557 405.7C283.501 402.272 298.615 396.789 318.759 389.479C365.723 372.438 436.696 346.686 461.28 329.965C468.014 325.385 468.92 316.783 465.898 311.44C460.821 302.457 446.089 302.209 427.458 310.801C427.153 310.942 426.84 311.069 426.522 311.182L317.039 350.152C315.834 350.58 314.563 350.8 313.282 350.8L208.998 350.799C202.809 350.799 197.793 345.783 197.793 339.594C197.793 333.405 202.809 328.389 208.998 328.389L311.347 328.389L418.544 290.233C454.353 273.903 476.553 284.755 485.406 300.41C494.623 316.71 489.563 337.832 473.884 348.497C446.98 366.798 377.29 392.084 326.404 410.546C306.239 417.864 288.822 424.183 282.706 427.052C281.217 427.749 279.592 428.11 277.948 428.11Z"
      />
      <motion.path
        variants={iconPath}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.213 416.126H21.2051C15.016 416.126 10 411.109 10 404.92V227.383C10 221.195 15.0162 216.178 21.2051 216.178H107.213C113.402 216.178 118.418 221.194 118.418 227.383V404.922C118.418 411.11 113.403 416.126 107.213 416.126ZM32.4104 393.717H96.0082V238.588H32.4104V393.717Z"
      />
      <motion.path
        variants={iconPath}
        d="M339.206 85.8945C305.127 85.8945 277.401 113.532 277.401 147.507C280.64 229.184 397.785 229.161 401.011 147.506C401.011 113.532 373.285 85.8945 339.206 85.8945ZM339.206 191.975C314.578 191.975 294.546 172.026 294.546 147.507C296.638 88.654 381.783 88.6691 383.867 147.508C383.867 172.026 363.834 191.975 339.206 191.975Z"
      />
      <motion.path
        variants={iconPath}
        d="M433.885 151.985C434.04 149.025 434.04 145.982 433.885 143.024L453.549 125.532C456.588 122.828 457.308 118.354 455.265 114.829L425.614 63.652C423.589 60.1486 419.369 58.5372 415.527 59.8054L390.388 68.0594C387.894 66.4606 385.307 64.9705 382.645 63.6018L377.254 37.8184C376.425 33.8462 372.926 31 368.866 31H309.555C305.495 31 301.996 33.8462 301.167 37.8184L295.776 63.6018C293.123 64.9663 290.536 66.4564 288.025 68.0594L262.903 59.8054C259.035 58.5372 254.841 60.1486 252.807 63.652L223.156 114.829C221.113 118.354 221.833 122.824 224.876 125.532L244.536 143.028C244.381 145.987 244.381 149.022 244.536 151.981L224.876 169.477C221.833 172.185 221.113 176.655 223.156 180.18L252.807 231.357C254.841 234.856 259.035 236.464 262.903 235.204L288.025 226.95C290.528 228.553 293.123 230.043 295.776 231.412L301.167 257.191C301.996 261.163 305.495 264.009 309.555 264.009H368.866C372.926 264.009 376.425 261.163 377.254 257.191L382.645 231.407C385.307 230.039 387.894 228.549 390.388 226.95L415.527 235.204C419.369 236.464 423.589 234.856 425.614 231.357L455.265 180.18C457.308 176.655 456.588 172.181 453.549 169.477L433.885 151.985ZM414.263 216.745L391.753 209.353C384.056 207.369 378.623 215.675 371.544 217.745C369.067 218.876 367.275 221.119 366.723 223.785L361.901 246.865H316.52L311.699 223.785C311.146 221.119 309.355 218.876 306.868 217.741C299.815 215.696 294.381 207.376 286.652 209.352C286.652 209.353 264.158 216.745 264.158 216.745L241.497 177.635L259.094 161.981C263.514 158.302 263.508 136.706 259.093 133.029C259.094 133.029 241.497 117.374 241.497 117.374L264.158 78.264L286.652 85.6557C294.368 87.6367 299.827 79.3208 306.877 77.2646C309.355 76.1335 311.146 73.89 311.698 71.2238L316.52 48.1443H361.901L366.723 71.2238C367.275 73.8858 369.067 76.1293 371.536 77.2636C378.63 79.3249 384.036 87.6435 391.752 85.6568C391.753 85.6557 414.263 78.264 414.263 78.264L436.924 117.374L419.319 133.029C414.89 136.707 414.899 158.307 419.319 161.98C419.319 161.98 436.924 177.635 436.924 177.635L414.263 216.745Z"
      />
    </motion.svg>
  );
}
